import DOMPurify from 'dompurify';
import richTextRenderer, { type RichTextJson } from '@rei/rich-text-renderer';

const DOMTools = {
  sanitize(html: string | Node) {
    return DOMPurify.sanitize(html);
  },
  richTextToHtml(json: RichTextJson, options?: { sanitize: boolean }) {
    const html = richTextRenderer(json);

    return options?.sanitize ? this.sanitize(html) : html;
  },
  waitForElement(selector: string, options?: { target?: HTMLElement } & MutationObserverInit) {
    const { target, ...observeOptions } = {
      target: document.body,
      childList: true,
      subtree: true,
      ...options,
    };

    return new Promise<Element>((resolve) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector)!);
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector)!);
          observer.disconnect();
        }
      });

      observer.observe(target, observeOptions);
    });
  },
  scroll(selector: string, options?: ScrollIntoViewOptions) {
    document.querySelector(selector)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      ...options,
    });
  },
};

export default DOMTools;
